var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.device === "mobile"
      ? _c("div", { staticClass: "xs-not-container" }, [
          _c("div", { staticClass: "xs-not-container-content" }, [
            _c("div", [
              _c("div", [
                _c("img", {
                  staticClass: "not-img",
                  attrs: {
                    width: "60%",
                    src: _vm.$store.getters.isAruxpay
                      ? require("@/assets/logo/aruxpay_logo_big.svg")
                      : require("@/assets/logo/logo_big.svg"),
                  },
                }),
              ]),
              _c("div", { staticClass: "not-find-form-container" }, [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "text-not-find color-main-linear-blue" },
                    [_vm._v(" 404 Not Found ")]
                  ),
                  _c("div", { staticClass: "not-find-content" }, [
                    _vm._v(
                      " The page you requested could not be found. It may have been moved or deleted "
                    ),
                  ]),
                  _c("div", [
                    _c("img", {
                      staticClass: "not-find-bottom-logo",
                      attrs: {
                        src: _vm.$store.getters.isAruxpay
                          ? require("@/assets/logo/aruxpay_logo.png")
                          : require("@/assets/logo/ezpay_logo.svg"),
                      },
                    }),
                    _c("div", { staticClass: "text-all-right" }, [
                      _vm._v(
                        "©️ " +
                          _vm._s(new Date().getFullYear()) +
                          " " +
                          _vm._s(
                            _vm.$store.getters.isAruxpay ? "Aruxpay" : "Ezpay"
                          ) +
                          " Information Solutions "
                      ),
                      _c("br"),
                      _vm._v(" Corp., All Rights Reserved"),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "not-find-container" }, [
          _c("div", { staticClass: "not-find-form-container" }, [
            _c("div", [
              _c(
                "div",
                { staticClass: "text-not-find color-main-linear-blue" },
                [_vm._v(" 404 Not Found ")]
              ),
              _vm._m(0),
              _c("div", [
                _c("img", {
                  staticClass: "not-find-bottom-logo",
                  attrs: {
                    src: _vm.$store.getters.isAruxpay
                      ? require("@/assets/logo/aruxpay_logo.png")
                      : require("@/assets/logo/ezpay_logo.svg"),
                  },
                }),
                _c("div", { staticClass: "text-all-right" }, [
                  _vm._v(
                    "©️ " +
                      _vm._s(new Date().getFullYear()) +
                      " " +
                      _vm._s(
                        _vm.$store.getters.isAruxpay ? "Aruxpay" : "Ezpay"
                      ) +
                      " Information Solutions Corp., All Rights Reserved"
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "not-find-img" }, [
            _c("img", {
              attrs: {
                width: "100%",
                src: _vm.$store.getters.isAruxpay
                  ? require("@/assets/logo/aruxpay_logo_big.svg")
                  : require("@/assets/logo/logo_big.svg"),
              },
            }),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "not-find-content" }, [
      _vm._v(" The page you requested could not be found."),
      _c("br"),
      _vm._v(" It may have been moved or deleted "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }